/**
 * Anchor Redirect Handler
 * Handles legacy anchor URLs that no longer exist after site restructure
 */

const ANCHOR_REDIRECTS = {
  '#features-pro': (lang) => `/${lang}/pro/#features`,
  '#features-care': (lang) => `/${lang}/care/#features`
};

export function initAnchorRedirects() {
  const hash = window.location.hash;

  if (!hash || !ANCHOR_REDIRECTS[hash]) return;

  // Determine current language from URL or default
  const pathLang = window.location.pathname.split('/')[1];
  const lang = ['en', 'ua'].includes(pathLang) ? pathLang : 'en';

  // Redirect to new location
  const newUrl = ANCHOR_REDIRECTS[hash](lang);
  window.location.replace(newUrl);
}
